export default __webpack_public_path__ + "static/media/preday_sparks.24704e00.jpg";